import React, { createContext, ReactNode, useState } from "react";
import {
  IMessageSnackbar,
  MessageAttachment,
  MessageRecords,
  MessageTypeEnum,
} from "./types";
import { MessageDirectionEnum } from "../../Premises/types";

interface IMessageTabProps {
  inputText?: string;
  showInputError: boolean;
  showDocumentTypeDialog: boolean;
  selectedAttachments: MessageAttachment[];
  displaySnackbar?: IMessageSnackbar;
  showFileDropZone: boolean;
  messageRecords: MessageRecords;
  scrollToLatestMessage: boolean;
  requestId?: string;
  journeyId?: string;
  rawRequestStatus?: string;
  latestMessageDirection?: MessageDirectionEnum;
  latestMessageProcessed?: boolean;
  latestMessageType?: MessageTypeEnum;
  hasUnreadMessageForUser?: boolean;
  messagePause?: boolean;
  type: MessageTypeEnum;
  blockRefId?: string;
  processingMessageTabClicked: boolean;
  processingMessagesFetched: boolean;
  actionButtonRef: React.MutableRefObject<HTMLDivElement | null> | undefined;
}

const defaultMessageTabState: IMessageTabProps = {
  inputText: undefined,
  showInputError: false,
  showDocumentTypeDialog: false,
  selectedAttachments: [],
  displaySnackbar: undefined,
  showFileDropZone: false,
  messageRecords: [],
  scrollToLatestMessage: true,
  requestId: undefined,
  journeyId: undefined,
  rawRequestStatus: undefined,
  latestMessageDirection: undefined,
  latestMessageProcessed: undefined,
  latestMessageType: undefined,
  hasUnreadMessageForUser: undefined,
  messagePause: undefined,
  type: MessageTypeEnum.STANDARD,
  blockRefId: undefined,
  processingMessageTabClicked: false,
  processingMessagesFetched: false,
  actionButtonRef: undefined,
};

export interface IMessageContext {
  messageTabState: IMessageTabProps;
  setMessageTabState: React.Dispatch<React.SetStateAction<IMessageTabProps>>;
}

export const MessageContext = createContext<IMessageContext>({
  messageTabState: defaultMessageTabState,
  setMessageTabState: () => {},
});

interface IFormProviderProps {
  children: ReactNode;
}

export const MessageContextProvider = ({ children }: IFormProviderProps) => {
  const [messageTabState, setMessageTabState] = useState(
    defaultMessageTabState
  );

  const value = {
    messageTabState,
    setMessageTabState,
  };
  return (
    <MessageContext.Provider value={value}>{children}</MessageContext.Provider>
  );
};
